// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

// --- RxJs
import { retryBackoff } from 'backoff-rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { environment } from '../../../../environments/environment';
import {
  ApplicationError,
  ErrorMessage,
  RespondentDeclineStages,
  RespondentTokenValidationModel,
  TokenValidationErrorTypes,
} from '../../../models';
import { AppService } from '../app.service';
import { RespondentDeclineBaseService } from './respondent-decline-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class RespondentDeclineService extends RespondentDeclineBaseService {
  constructor(
    private http: HttpClient,
    private appService: AppService,
    private translateService: TranslateService,
    router: Router
  ) {
    super(router);
  }

  resolveToken(token: string): void {
    if (!token) {
      return;
    }

    const url =
      environment.apiConfig.surveyApiUrl +
      environment.apiConfig.respondentValidationApi +
      `/${token}`;

    this.http
      .get<RespondentTokenValidationModel>(url)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._validationError.bind(this))
      )
      .subscribe((result: RespondentTokenValidationModel) => {
        this._fullName$.next(result.participantName);
        this._emailAddress$.next(result.participantEmailAddress);
        this._tokenValidation$.next(result.tokenValidationErrorType);
        this._tokenResolved$.next(true);
      });
  }

  decline(token: string): void {
    this._declineStage$.next(RespondentDeclineStages.declining);
    const url =
      environment.apiConfig.surveyApiUrl +
      environment.apiConfig.respondentDeclineApi +
      `/${token}`;

    this.http
      .post<RespondentTokenValidationModel>(url, null)
      .pipe(
        retryBackoff(environment.retryConfig),
        catchError(this._declineError.bind(this))
      )
      .subscribe((result) => {
        this._declineStage$.next(RespondentDeclineStages.declined);
      });
  }

  private _validationError(err: any) {
    return of({
      tokenValue: '',
      hasPassword: false,
      tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
      locale: '',
      applicationError: {
        errorMessage: 'errorHeaderUnexpected',
        detailedMessage: 'respondentValidationUnexpectedError',
      },
    } as RespondentTokenValidationModel);
  }

  private _declineError(err: any) {

    const error: ApplicationError = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'RespondentDeclineService',
      false,
      err
    );

    this.appService.setLastError(error);
    return of(0);
  }
}
